import { FC, ReactNode, memo } from 'react';
import Typography from '../Typography';
import { WalletSkeleton } from '../Wallet';

import './ProductHeader.scss';

interface ProductHeaderProps {
  title: string;
  beforeTitle?: ReactNode;
  afterTitle?: ReactNode;
}

const ProductHeaderSkeletonComponent: FC<ProductHeaderProps> = ({ title, beforeTitle, afterTitle }) => {
  return (
    <div className="nostra__productHeader">
      <div className="nostra__productHeader__titleContainer">
        {beforeTitle}
        <Typography className="nostra__productHeader__title" variant="heading-lg" weight="semi-bold">
          {title}
        </Typography>
        {afterTitle}
      </div>
      <div className="nostra__productHeader__actions">
        <WalletSkeleton />
      </div>
    </div>
  );
};
export const ProductHeaderSkeleton = memo(ProductHeaderSkeletonComponent);
